import { render } from "./HotelPage.vue?vue&type=template&id=1f835110&ts=true"
import script from "./HotelPage.vue?vue&type=script&lang=ts"
export * from "./HotelPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__